<template>
  <falquick-card title="Fees Payments SMS Alerts">
    <template v-slot:header-actions></template>
    <template v-slot:card-content>
      <v-layout row>
        <v-switch
          label="Send SMS alert on fees payment to student's guardian"
          :true-value="1"
          v-model="falert_status"
          @change="setFeesPaymentAlert($event)"
        ></v-switch>
      </v-layout>
    </template>
  </falquick-card>
</template>

<script>
import { mapGetters } from "vuex";
import QuickCard from "../Quickcard";
export default {
  name: "fees-payment-alert",
  components: {
    "falquick-card": QuickCard
  },
  data() {
    return {
      falert_status: null
    };
  },
  mounted() {
    this.$store.dispatch("settings/getAll").then(res => {
      this.falert_status = this.settings.sms.alert_status
        ? Number(this.settings.sms.alert_status)
        : Number(0);
    });

    // console.log("dssdfsd",this.falert_status)
  },
  computed: {
    ...mapGetters({
      settings: "settings/SETTINGS",
      serrors: "settings/SETTING_ERROR",
      sloading: "settings/SETTING_LOADING"
    })
  },
  methods: {
    setFeesPaymentAlert(val) {
      //console.log(val)
      let c = val == false ? 0 : 1;
      localStorage.setItem("falert_status", c);
      this.$store.dispatch("settings/add", { smsalert_status: c });

      if (this.serrors == null) {
        this.$store.dispatch("responseMessage", {
          type: "success",
          text: "Settings saved successfully.",
          title: "Save Settings",
          modal: false
        });
      } else {
        this.sinf_model = this.sinf_modelcp;
        this.$store.dispatch("responseMessage", {
          type: "warning",
          text: "Sorry settings could not be saved.",
          title: "Save Settings",
          modal: false
        });
      }
    }
  },
  watch: {
    settings(val) {
      if (val) {
        //console.log(val)
        this.falert_status = val.sms.alert_status ? val.sms.alert_status : 0;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/settings/feesAlert.vue